
import Vue from "vue";
import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import "./dropdown.less";
import {getLifechallengeCategoryBaseUrl} from "@/services/getCategoryData/getCategoryData";
import {setCookie} from "@/services/cookieClient/cookieClient";

@Component
export default class SimpleDropdown extends Vue {
  @Prop() value: any;
  @Prop(Array) dataSource!: Array<any>;
  @Prop(String) displayProp!: string;
  @Prop(String) placeholder!: string;
  @Prop(Boolean) nullable = false;
  @Prop(Boolean) changeUrl = false;

  mounted(){
  }

  inputChange(item){
    this.input(item);
  }


  getChangeUrl(){
    return this.changeUrl;
  }

  @Watch("value")
  private selectedChange(value) {
    if(value.id == ''){
      //@ts-ignore
      $(this.$refs.countrySelector[0]).click();
    }
  }

  @Emit()
  input(item) {
  }
}
